import AppNavbar from "@/components/layout/AppNavbar";
import Footer from "@/components/layout/Footer";
import { SUPPORT_EMAIL } from "@/shared/constants/support";

import { Col } from "react-bootstrap";
// import 'bootstrap/dist/css/bootstrap.min.css';
import "@/assets/css/style.css";

function Terms() {
  return (
    <>
      <AppNavbar />
      <main className="container-lg nav-padding">
        <Col lg={{ span: 8, offset: 2 }} className="py-5">
          <h2 className="mb-4">Terms and Conditions</h2>
          <p>
            Welcome to Favluv! These Terms and Conditions ("Terms") govern your
            access to and use of the Favluv platform ("Favluv" or the
            "Service"), operated by Wishcan Inc. ("we," "us," or "our"). By
            accessing or using Favluv, you agree to be bound by these Terms. If
            you do not agree, please do not use the Service.
          </p>

          <h3 className="mt-4 mb-3">1. Acceptance of Terms</h3>
          <p>
            By creating an account, accessing, or using Favluv, you confirm that
            you are at least 13 years old and that you are legally capable of
            entering into these Terms. If you are using Favluv on behalf of a
            company, organization, or other entity, you represent that you have
            the authority to bind that entity to these Terms.
          </p>

          <h3 className="mt-4 mb-3">2. Privacy</h3>
          <p>
            Your use of Favluv is subject to our Privacy Policy, which explains
            how we collect, use, and protect your information. By using the
            Service, you consent to the practices described in the Privacy
            Policy.
          </p>

          <h3 className="mt-4 mb-3">3. Account Registration and Security</h3>
          <ul>
            <li>
              You are responsible for maintaining the confidentiality of your
              account credentials and for all activities that occur under your
              account.
            </li>
            <li>
              You agree to provide accurate, current, and complete information
              during registration and to update such information to keep it
              accurate.
            </li>
            <li>
              We reserve the right to suspend or terminate your account if you
              violate these Terms or if we suspect unauthorized activity.
            </li>
          </ul>

          <h3 className="mt-4 mb-3">4. Use of the Service</h3>
          <ul>
            <li>Favluv is provided for personal and non-commercial use.</li>
            <li>
              You agree not to:
              <ul>
                <li>Use the Service for illegal purposes or activities.</li>
                <li>
                  Upload, post, or share content that is obscene, defamatory,
                  harassing, hateful, or violates the rights of others.
                </li>
                <li>
                  Impersonate another person or misrepresent your affiliation
                  with any entity.
                </li>
                <li>
                  Interfere with or disrupt the Service, including transmitting
                  viruses or harmful code.
                </li>
              </ul>
            </li>
            <li>
              We may monitor and remove content that violates these Terms.
            </li>
          </ul>

          <h3 className="mt-4 mb-3">5. Content Ownership and Rights</h3>
          <ul>
            <li>
              You retain ownership of the content you create and post on Favluv.
              By posting content, you grant us a worldwide, royalty-free,
              non-exclusive license to use, reproduce, modify, distribute, and
              display your content in connection with operating and improving
              the Service.
            </li>
            <li>
              You represent and warrant that you have the right to share any
              content you post and that doing so does not infringe any
              third-party rights.
            </li>
          </ul>

          <h3 className="mt-4 mb-3">6. Intellectual Property</h3>
          <ul>
            <li>
              All intellectual property rights in Favluv, including but not
              limited to software, design, text, and graphics, are owned by
              Wishcan Inc. or our licensors.
            </li>
            <li>
              You may not copy, modify, distribute, sell, or lease any part of
              the Service unless explicitly authorized by us.
            </li>
          </ul>

          <h3 className="mt-4 mb-3">7. Termination</h3>
          <ul>
            <li>
              We reserve the right to suspend or terminate your access to Favluv
              at our sole discretion, with or without notice, for any violation
              of these Terms or other conduct that we deem harmful to the
              Service.
            </li>
            <li>
              You may terminate your account at any time by following the
              account deletion process within the Service.
            </li>
          </ul>

          <h3 className="mt-4 mb-3">8. Disclaimers</h3>
          <p>
            Favluv is provided "as is" and "as available" without any warranties
            of any kind, whether express or implied. We do not guarantee that
            the Service will be uninterrupted, error-free, or free from viruses
            or other harmful components.
          </p>

          <h3 className="mt-4 mb-3">9. Payments, Agency Relationship, and Funds Flow</h3>

          <p>
            <strong>9.1 Agent of the Payee.</strong> Favluv acts solely as a limited
            payment collection agent of the applicable seller, creator, or other payee
            (each, a “Seller”) for the purpose of accepting payments from users on
            behalf of such Seller. Payment by a user to Favluv shall be considered the
            same as payment made directly to the Seller, and the Seller shall be
            deemed to have received payment at the time Favluv accepts such payment on
            the Seller’s behalf.
          </p>

          <p>
            <strong>9.2 No Custodial Relationship.</strong> Favluv does not act as a
            custodian, trustee, escrow agent, or fiduciary with respect to user funds.
            Favluv does not hold or store funds for the benefit of users; rather,
            Favluv receives funds solely in its capacity as agent of the Seller and
            facilitates the onward transmission of such funds to the Seller in
            accordance with these Terms and applicable payment processor agreements.
          </p>

          <p>
            <strong>9.3 Payment Processing.</strong> Payments made through Favluv may
            be processed by third-party payment processors. Your use of such payment
            services may be subject to separate terms and conditions imposed by the
            applicable payment processor. Favluv is not responsible for the acts or
            omissions of any third-party payment processor.
          </p>

          <p>
            <strong>9.4 Fees and Deductions.</strong> Favluv may deduct applicable
            service fees, commissions, refunds, chargebacks, or taxes from amounts
            collected on behalf of Sellers, as disclosed to Sellers or otherwise
            agreed between Favluv and the Seller.
          </p>

          <p>
            <strong>9.5 Seller Responsibility.</strong> Sellers are solely responsible
            for fulfilling their obligations to users, including delivery of goods,
            services, or content, and for handling disputes, refunds, and customer
            service obligations, except to the extent expressly stated otherwise by
            Favluv.
          </p>

          <p>
            <strong>9.6 Refunds</strong> Transactions on Favluv are considered final with no refunds.  In cases of dispute, please contact Favluv.  Favluv will review such dispute in accordance with its dispute resolution policy, and may, in its sole discretion, issue a refund or other remedy.  The refund amount will be withdrawn from the Seller's account.
          </p>

          <h3 className="mt-4 mb-3">10. Limitation of Liability</h3>
          <ul>
            <li>
              To the fullest extent permitted by law, Wishcan Inc. shall not be
              liable for any indirect, incidental, consequential, or punitive
              damages arising out of your use of Favluv.
            </li>
            <li>
              Our total liability for any claims arising from the Service will
              not exceed the amount you paid us, if any, for access to the
              Service.
            </li>
          </ul>

          <h3 className="mt-4 mb-3">11. Governing Law</h3>
          <p>
            These Terms shall be governed by and construed in accordance with
            the laws of [Insert Jurisdiction], without regard to its conflict of
            laws principles.
          </p>

          <h3 className="mt-4 mb-3">12. Changes to the Terms</h3>
          <p>
            We may update these Terms from time to time. If we make material
            changes, we will notify you by posting the updated Terms on Favluv
            and updating the "Last Updated" date. Your continued use of the
            Service after the changes take effect constitutes your acceptance of
            the updated Terms.
          </p>

          <h3 className="mt-4 mb-3">13. Contact Us</h3>
          <p>
            If you have any questions about these Terms, please contact us at:
          </p>
          <address>
            <strong>Wishcan Inc.</strong>
            <br />
            2233 Wind River Ln
            <br />
            Rowland Heights, CA, 91748
            <br />
            Email:{" "}
            <span className="email">
              {SUPPORT_EMAIL}
            </span>
          </address>

          <p>
            By using Favluv, you acknowledge that you have read, understood, and
            agree to these Terms and Conditions.
          </p>
        </Col>
      </main>
      <Footer />
    </>
  );
}

export default Terms;
